import { render, staticRenderFns } from "./IndexCdr.vue?vue&type=template&id=055505c0&scoped=true&"
import script from "./IndexCdr.vue?vue&type=script&lang=js&"
export * from "./IndexCdr.vue?vue&type=script&lang=js&"
import style0 from "./IndexCdr.vue?vue&type=style&index=0&id=055505c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055505c0",
  null
  
)

export default component.exports